import { render, staticRenderFns } from "./businessChange.vue?vue&type=template&id=d9cfff2c&scoped=true&"
import script from "./businessChange.vue?vue&type=script&lang=js&"
export * from "./businessChange.vue?vue&type=script&lang=js&"
import style0 from "./businessChange.vue?vue&type=style&index=0&id=d9cfff2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9cfff2c",
  null
  
)

export default component.exports